module.exports = __webpack_public_path__ + "media/mail/email_logo@2x-7fbb8e5e.png";